// extracted by mini-css-extract-plugin
var _1 = "xWWuv";
var _2 = "YKXkv";
var _3 = "QcaE0";
var _4 = "Y6oBQ";
var _5 = "qqaBo";
var _6 = "BYMN0";
export { _1 as "detailsLine", _2 as "lineAction", _3 as "lineTitle", _4 as "lineValue", _5 as "statusValue", _6 as "subscriptionSection" }
